module.exports = __webpack_public_path__ + "static/media/Anmol_Agarwal.14881195.jpg";